

import PopUpDialog from './components/PopUpDialog.vue'


import { Component, Vue } from 'vue-property-decorator'
import { mapGetters, mapActions } from 'vuex'

@Component({
  computed: {
    ...mapGetters({
      getDarkMode: 'getDarkMode',
      getTaskStatus: 'getTaskStatus',
    }),
  },
  methods: {
    ...mapActions({
      fetchCfgFromServerByName: 'fetchCfgFromServerByName',
      setSnackBarText: 'setSnackBarText',
      setStartLoadingConfig: 'setStartLoadingConfig',
      setConfigLoaded: 'setConfigLoaded',
      clearStoreState: 'clearStoreState',
    }),
  },
  components: {    
    PopUpDialog,
  },
})
export default class App extends Vue {
  
  private name: any = 'App'

}
